import { Center, Image } from "@chakra-ui/react";

function Planning(){
  const graphicSrc = require(`../../../../../assets/360-planning/360-planning.png`);

  return <Center>
      <Image src={graphicSrc} height={700} width={700}/>
    </Center>;
}

export default Planning;